import { toast } from "react-toastify";
import React from "react";

export const notification = (message, type = "info") => {
  toast(<div>{message}</div>, {
    className: `${type}-toast`,
    progressClassName: `${type}-bar`,
  });
};
